import containerFuild from '../html-snippets/container-fuild';
import css from '../tpl-css/style-section-cefloreco-footer.js';

const html = `
<div
  data-use-custom-width="false"
  data-custom-width="1204"
  class="container marquee-group"
  data-attribute="container-content"
  style="--custom-width: 1204px;"
>
  <div class="layout-footer">
    <div class="logo-company">
      <img
        class="logo-image"
        data-attribute="logo-image"
        src="https://cdn.skyfastimg.com/images/2026/10/27/image-6ae0622d6f255d21e2325163.webp?w=1000&q=100"
        alt=""
      />
      <div class="desc-company" data-attribute="desc-company">Digital entertainment, beautifully made.</div>
    </div>
    <div class="main-footer">
      <div class="col-item our-product">
        <div data-attribute="title-column-product" class="title-column">OUR PRODUCT</div>
        <div data-attribute="list-item-product" class="list-item">
          <a href="" data-attribute="item-child" class="item-child">Shortpeek</a>
          <a href="" data-attribute="item-child" class="item-child">IQ Myth</a>
          <a href="" data-attribute="item-child" class="item-child">Leaforeal</a>
          <a href="" data-attribute="item-child" class="item-child">Entropy Brain</a>
        </div>
      </div>
      <div class="col-item company-info">
        <div data-attribute="title-column-company" class="title-column">COMPANY INFO</div>
        <div data-attribute="list-item-company" class="list-item">
          <a href="" data-attribute="item-child" class="item-child">Contact Us</a>
          <a href="" data-attribute="item-child" class="item-child">About Us</a>
        </div>
      </div>
      <div class="col-item legal">
        <div data-attribute="title-column-legal" class="title-column">LEGAL</div>
        <div data-attribute="list-item-legal" class="list-item">
          <a href="" data-attribute="item-child" class="item-child">Privacy Policy</a>
          <a href="" data-attribute="item-child" class="item-child">Terms of Service</a>
          <a href="" data-attribute="item-child" class="item-child">Cookie Policy</a>
          <a href="" data-attribute="item-child" class="item-child">Public Statement</a>
        </div>
      </div>
      <div class="col-item contact">
        <div data-attribute="title-column-contact" class="title-column">CONTACT</div>
        <div data-attribute="list-item-contact" class="list-item">
          <div class="item-group address" data-attribute="contact-item">
            <div class="label-item" data-attribute="contact-label">ADDRESS</div>
            <a href="" data-attribute="contact-link">114 LAVENDER STREET, #10-05, CT HUB 2, SINGAPORE 338729</a>
          </div>
          <div class="item-group email" data-attribute="contact-item">
            <div class="label-item" data-attribute="contact-label">EMAIL</div>
            <a href="mailto:studio@cefloreco.com" data-attribute="contact-link">studio@cefloreco.com</a>
          </div>
        </div>
      </div>
    </div>
    <div data-attribute="copyright">© 2026 CEFLORE PTE. LTD</div>
  </div>
</div>
`;

export default containerFuild(html, css, {
  backgroundColor: '#000',
  textColor: '#ffffff',
  topPadding: false,
  bottomPadding: false,
});
